// src/hooks/pricingUnits/useForceDeletePricingUnit.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeletePricingUnit } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";

const useForceDeletePricingUnit = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeletePricingUnitMutation,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeletePricingUnit,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete pricing unit");
        },
    });

    return {
        forceDeletePricingUnit: forceDeletePricingUnitMutation,
        isPending: isPending || isLoading,
    };
};

export default useForceDeletePricingUnit;
